var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.url)?_c('iframe',{attrs:{"id":"userplayer","frameborder":"0","src":_vm.url + '&lang=Ru-ru&disableSupport=1',"allow":"camera;microphone;fullscreen;accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture;display-capture;","allowusermedia":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }